import { Language } from '../i18n';
import { logClient } from '../log';

/**
 * ⚠
 * TO BE CONSIDERED:
 * Number/Date/Time formatting is done via native Intl API (in-browser) to avoid
 * 3rd party dependency. However, this API might not be available depending on browser
 * target and versions. Once our browser targets are clear, we might want
 * to provide locale-data fallbacks/polyfills for old non-compatible browsers.
 * In that case:
 *
 * TIPS:
 * - Format.js -> react-intl has either Intl API polyfill as well as locale-data
 *   polyfills, just in case it is needed.
 * - Instructions, for example:
 *   https://formatjs.io/docs/polyfills/intl-numberformat
 *
 * PENDING: Discuss if fallback polyfills should be applied to target old browsers.
 */

export const isIntlAPISupported = (formatter: 'NumberFormat' | 'DateTimeFormat') => {
  const supported = typeof Intl?.[formatter] === 'function';
  if (!supported) {
    logClient.logColor('orange', '[Localization] Browser does not support Intl API');
  }
  return supported;
};

// Fallbacks if no Intl API is detected in browser.

export const getNumberFormatterFallback = (language?: Language | string) => (n: number) =>
  n?.toLocaleString(language);
export const getDateTimeFormatterFallback = (language?: Language | string) => (d: Date) =>
  d?.toLocaleString(language);
